﻿import $ from "jquery";
import { GuiBase } from "../GuiBase";
import { AppLog } from "../AppLog";

export class GuiOcrUpload extends GuiBase {

    constructor() {
        super("Dokument");
    }

    upload() {
        AppLog.logInfo("upload");
        this.lock();

        $("#frmUpload").submit();
    }

}
